import { WHY_OSWAL } from "@/data/content";
import { Eyebrow, MaskedLines, Reveal } from "./shared";

export default function WhyOswal() {
  return (
    <section
      id="why-oswal"
      data-testid="why-oswal-section"
      className="bg-mist py-28 md:py-36"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid items-end gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Eyebrow>Why Oswal</Eyebrow>
            <h2 className="mt-7 font-serif font-medium leading-[1.0] tracking-tight text-navy">
              <MaskedLines
                lines={[
                  <span key="a" style={{ fontSize: "clamp(2.6rem, 5.6vw, 5.4rem)" }} className="block">
                    WHY OSWAL<span className="text-brand">.</span>
                  </span>,
                ]}
              />
            </h2>
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={0.2}>
              <p className="max-w-md font-serif text-2xl font-normal italic leading-snug text-ink/80 md:text-3xl">
                Quality products. Honest prices. Customers first.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-20">
          {WHY_OSWAL.map((item, i) => (
            <Reveal key={item.n} delay={i * 0.06} y={26}>
              <div
                className={`group grid items-baseline gap-3 border-t border-brand/12 py-9 transition-colors duration-500 hover:bg-white md:grid-cols-12 md:gap-6 md:py-11 ${
                  i === WHY_OSWAL.length - 1 ? "border-b" : ""
                }`}
                data-testid={`why-item-${item.n}`}
              >
                <span className="font-serif text-lg italic text-fog transition-colors duration-500 group-hover:text-brand md:col-span-2 md:pl-2">
                  {item.n}
                </span>
                <h3 className="font-serif text-3xl font-semibold tracking-[0.08em] text-navy transition-all duration-500 group-hover:translate-x-2 group-hover:text-brand md:col-span-5 md:text-4xl">
                  {item.title}
                </h3>
                <p className="max-w-sm text-[15px] leading-relaxed text-fog md:col-span-5">
                  {item.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
